import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-two-options-popup',
  templateUrl: './two-options-popup.component.html',
  styleUrls: ['./two-options-popup.component.scss'],
  standalone: false,
})
export class TwoOptionsPopupComponent {
  public title: string = '';
  public success: string = '';
  public cancel: string = '';
  public successColor: string;
  public cancelColor: string;
  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {
    this.title = this.navParams.get('title');
    this.success = this.navParams.get('success');
    this.cancel = this.navParams.get('cancel');
  }

  selectOption(res: any) {
    this.modalCtrl.dismiss(res);
  }
}
